import React from 'react';
import { Box } from '@mui/material';

import { Typography, Link } from '@occc-app/design-system';

import { BackgroundImage } from '../../BackgroundImage';
import { State as MarketingContentState } from '../../MarketingContent/redux';

const ViewLink: React.FC<{ url: string; urlType: string }> = ({ url, urlType }) => {
  const viewLinkComponent = url ? (
    <Link href={url} display='block'>
      View Link
    </Link>
  ) : (
    <>(No {urlType} URL configured)</>
  );
  return viewLinkComponent;
};

export const MarketingContentSummary: React.FC<MarketingContentState> = ({
  title,
  imageUrl,
  shortDescription,
  longDescription,
  terms,
  termsUrl,
  disclaimer,
  disclaimerUrl,
}) => {
  return (
    <Box display={['block', 'flex']} alignItems='flex-start'>
      <BackgroundImage src={imageUrl} borderRadius='4px' mb={1} mr={3} />
      <Box flex='1'>
        <Typography component='h4' variant='h6' paragraph>
          {title}
        </Typography>
        <Typography gutterBottom>{shortDescription}</Typography>
        <Typography paragraph>{longDescription}</Typography>
        <Box display={['block', 'flex']} mt={3}>
          <Box mb={3}>
            <Typography component='h4' variant='h6' paragraph>
              Terms and Conditions
            </Typography>
            <Typography variant='body2'>
              {terms}
              <ViewLink url={termsUrl} urlType='Terms' />
            </Typography>
          </Box>
          <Box mb={3}>
            <Typography component='h4' variant='h6' paragraph>
              Disclaimer
            </Typography>
            <Typography variant='body2'>
              {disclaimer}
              <ViewLink url={disclaimerUrl} urlType='Terms' />
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
